import React, { useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/45913855623356:1';
const purchases = [{
  name: 'Martín G.',
  city: 'Buenos Aires',
  photo: 'https://randomuser.me/api/portraits/men/22.jpg'
}, {
  name: 'Claudia R.',
  city: 'Córdoba',
  photo: 'https://randomuser.me/api/portraits/women/28.jpg'
}, {
  name: 'Federico L.',
  city: 'Rosario',
  photo: 'https://randomuser.me/api/portraits/men/45.jpg'
}, {
  name: 'Ana Paula M.',
  city: 'Mendoza',
  photo: 'https://randomuser.me/api/portraits/women/12.jpg'
}, {
  name: 'Roberto S.',
  city: 'La Plata',
  photo: 'https://randomuser.me/api/portraits/men/60.jpg'
}, {
  name: 'Silvina D.',
  city: 'Tucumán',
  photo: 'https://randomuser.me/api/portraits/women/33.jpg'
}, {
  name: 'Diego F.',
  city: 'Mar del Plata',
  photo: 'https://randomuser.me/api/portraits/men/36.jpg'
}, {
  name: 'Lorena V.',
  city: 'Salta',
  photo: 'https://randomuser.me/api/portraits/women/41.jpg'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Show first popup after 5 seconds
    const initialTimer = setTimeout(() => {
      if (!isDismissed) {
        setIsVisible(true);
      }
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, [isDismissed]);
  useEffect(() => {
    if (!isVisible || isDismissed) return;
    // Hide after 4 seconds, then show next after 2 more seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);
    const showNextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setIsVisible(true);
    }, 7000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(showNextTimer);
    };
  }, [isVisible, currentIndex, isDismissed]);
  const handleClick = () => {
    window.open(CHECKOUT_URL, '_blank');
  };
  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsDismissed(true);
    setIsVisible(false);
  };
  const current = purchases[currentIndex];
  return <AnimatePresence data-id="element-191">
      {isVisible && !isDismissed && <motion.div initial={{
      opacity: 0,
      y: 100,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 100
    }} transition={{
      duration: 0.35,
      ease: 'easeOut'
    }} onClick={handleClick} className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-2xl border border-gray-200 p-4 max-w-xs cursor-pointer hover:shadow-xl transition-shadow" data-id="element-192">
          <button onClick={handleDismiss} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar" data-id="element-193">
            <XIcon className="w-4 h-4" data-id="element-194" />
          </button>
          <div className="flex items-center gap-3" data-id="element-195">
            <img src={current.photo} alt={current.name} className="w-12 h-12 rounded-full object-cover border-2 border-green-500 flex-shrink-0" loading="lazy" decoding="async" data-id="element-196" />
            <div data-id="element-197">
              <p className="text-sm font-semibold text-gray-900" data-id="element-198">
                {current.name} de {current.city}
              </p>
              <p className="text-xs text-gray-600" data-id="element-199">
                acaba de adquirir el Manual Académico
              </p>
              <p className="text-xs text-green-600 font-medium mt-1" data-id="element-200">
                Hace unos momentos
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}